import { get } from 'lodash-es';

import { safeJSONParse } from '@kargotech/tms-common/Utilities/formatters';

export interface INotificationItem {
  key: string;
  actionCode: string;
  time: string;
  content: string;
  isRead: boolean;
  payload: any;
}

export const notifications = (data, locale = 'id') => {
  const notificationRawList = get(data, 'companyInAppNotifications.edges');
  const badgeCount = Number(get(data, 'unreadNotifications.count')) || 0;
  const notificationList = Array.isArray(notificationRawList)
    ? notificationRawList.map((notification) => ({
      key: get(notification, 'node.ksuid') as string,
      actionCode: get(notification, 'node.actionCode') as string,
      time: get(notification, 'node.notificationTime'),
      content: {
        id: get(notification, 'node.idNotificationContent') as string,
        en: get(notification, 'node.enNotificationContent') as string,
      }[locale],
      isRead: Boolean(get(notification, 'node.isRead')),
      payload: safeJSONParse(get(notification, 'node.actionPayload')),
    } as INotificationItem))
    : [];
  const pageInfo = {
    endCursor: get(data, 'companyInAppNotifications.pageInfo.endCursor') as string,
    hasNextPage: get(data, 'companyInAppNotifications.pageInfo.hasNextPage') as string,
  };

  return { notificationList, badgeCount, pageInfo } as const;
};

export default {};
